import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';

function insertPlaceholders(message, placeholders) {
  var _context;

  var PLACEHOLDER_REGEX = /({{[a-zA-Z0-9]+}})/g;

  var parts = _filterInstanceProperty(_context = message.split(PLACEHOLDER_REGEX)).call(_context, Boolean);

  return _mapInstanceProperty(parts).call(parts, function (part) {
    if (part.match(PLACEHOLDER_REGEX)) {
      var _key = part.replace(/[{}]+/g, '');

      return placeholders[_key];
    }

    return part;
  });
}

export { insertPlaceholders as default };
